export const COMPARISON_FEATURE_SECTION_ROWS_PER_BLOCK = 5;
export const COMPARISON_FEATURE_SECTION_MAX_BLOCKS = 6;

export const COMPARISON_FEATURE_SECTION_LAYOUT_CONSTANTS = {
  LAYOUT_ID: 'comparison-feature-section-layout',
  PLACEHOLDER_HEADING: 'Section Heading',
  PLACEHOLDER_SUBHEADING: 'Section subheading',
  PLACEHOLDER_BLOCK_HEADING: 'Block heading',
  PLACEHOLDER_BLOCK_DESCRIPTION: 'Block description',
  PLACEHOLDER_FEATURE: 'Feature',
  PLACEHOLDER_VALUE: 'Value',
  DEFAULT_TOPFAN_LABEL: 'TopFan',
  DEFAULT_COMPETITOR_LABEL: 'Competitor',
  DEFAULT_ALT_BLOCK_IMAGE: 'Block image',
  LABEL_FEATURE: 'Feature'
} as const;
